import React from "react";
export const DropdownItemContext = /*#__PURE__*/React.createContext({
  size: "m",
  selectionMode: "single"
});
//# sourceMappingURL=DropdownItemContext.js.map